<template>
  <div id="detail" class="card m-2 shadow-sm">
    <div v-if="!order.id" class="no-order">
      <h2>No Order Selected</h2>
    </div>
    <div v-if="order.id">
      <div class="navbar nav px-2 border-bottom bg-light">
        <action-buttons :order="order"></action-buttons>
      </div>
      
      <order-meta :order="order"></order-meta>
      <div class="">
        <ul class="nav nav-tabs">
          <li class="nav-item m-r" style="width: 15px;"></li>
          <li class="nav-item">
            <a class="nav-link active" href="#" data-toggle="tab" data-target="#items" aria-expanded="false">Line Items</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="tab" data-target="#inv" aria-expanded="false">Allocated Inventory</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="tab" data-target="#docs" aria-expanded="true">Documents</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="tab" data-target="#billable" aria-expanded="false">Billable
              Activity</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="tab" data-target="#history" aria-expanded="false">
              History
            </a>
          </li>          
        </ul>
      </div>

      <div class="tab-content bg-white">
        <div class="tab-pane active" id="items">
          <items-tab :order="order"></items-tab>
        </div>
        <div class="tab-pane" id="inv">
          <allocated-tab :order="order"></allocated-tab>
        </div>
        <div class="tab-pane" id="docs">
          <docs-tab :order="order"></docs-tab>
        </div>
        <div class="tab-pane" id="billable">
          <billable-tab :order="order"></billable-tab>
        </div>
        <div class="tab-pane" id="history">
          <history-tab :order="order"></history-tab>
        </div>        
      </div>
    </div>
  </div>
</template>

<script>
  import OrderMeta from '@/components/outbound/OrderMeta'
  import ItemsTab from '@/components/outbound/ItemsTab'
  import DocsTab from '@/components/outbound/DocsTab'
  import BillableTab from '@/components/outbound/BillableTab'
  import AllocatedTab from '@/components/outbound/AllocatedTab'
  import HistoryTab from '@/components/outbound/HistoryTab'
  import ActionButtons from '@/components/outbound/ActionButtons'

  export default {
    name: 'order-detail',

    components: {
      OrderMeta,
      ItemsTab,
      DocsTab,
      BillableTab,
      HistoryTab,
      AllocatedTab,
      ActionButtons,
    },

    props: ['order'],

    methods: {

    }
  }
</script>
<style scoped>
.no-order {
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: space-around;
  height: calc(100vh - 48px);
  flex-direction: column;
}

.no-order h2 {
  justify-self: center;
  color: #cfcfcf;
}
</style>